var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',_vm._g(_vm._b({attrs:{"action":_vm.action,"name":_vm.name,"headers":_vm.headers,"on-error":_vm.onError}},'el-upload',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }